module.exports = "/_next/static/images/6e68b236770d5c257fa6194ccd800a6b-man-holding-two-phones@3x.jpg";